//Data link escape
const DLE = 0x10;

export function getUint16Value(
  array: Uint8Array,
  position: number,
  littleEndian?: boolean
): number {
  if (position + 1 >= array.length) {
    return Number.MAX_SAFE_INTEGER;
  }

  const low = array[position];
  const high = array[position + 1] & 0xff;

  if (littleEndian) {
    return low + high * 256;
  } else {
    return 256 * low + high;
  }
}

export function getUint8Value(array: Uint8Array, position: number): number {
  if (position >= array.length) {
    return Number.MAX_SAFE_INTEGER;
  }

  return array[position] & 0xff;
}

export function getUint16(array: Uint8Array, index: number): number {
  return array[index] * 256 + array[index + 1];
}

export function getUint32(array: Uint8Array, index: number): number {
  return (
    (array[index + 3] & 0xff) +
    (array[index + 2] & 0xff) * 256 +
    (array[index + 1] & 0xff) * 65536 +
    (array[index] & 0xff) * 16777216
  );
}

export function uint8ArrayToString(buffer: Uint8Array): string {
  const filtered = buffer.filter((value) => value !== 0);

  return Buffer.from(filtered).toString("utf-8");
}

export function getPayload(array: Uint8Array): Uint8Array {
  const payloadIndices: number[] = [];

  let skipNexControlByte = false;

  for (let i = 1; i < array.length - 1; i++) {
    const uInt = array[i];
    if (skipNexControlByte) {
      payloadIndices.push(i);
      skipNexControlByte = false;
    } else {
      if (uInt === DLE) {
        skipNexControlByte = true;
      } else {
        payloadIndices.push(i);
      }
    }
  }

  const result = new Uint8Array(payloadIndices.length);
  let resultIndex = 0;

  for (const index of payloadIndices) {
    result[resultIndex++] = array[index];
  }

  return result;
}

export function hexToUint8Array(hexString: string): Uint8Array {
  return Uint8Array.from(Buffer.from(hexString, "hex"));
}

export function isBitSet(data: {
  value: number;
  bitIndex: number;
}) {
  const { value, bitIndex } = data;

  return ((value >> bitIndex) % 2 !== 0);
}